import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabaseMutationFn, useSupabaseTypedClient } from 'hooks/reactQuery';
import { useToastWrapper } from 'hooks/useToastWrapper';

import { useCurrentUser } from 'auth/CurrentUserProvider';
import { EdgeFunctionName } from 'types/edgeFunctions';
import { TanstackQueryName } from 'types/frontend';

interface DeleteRoastParams {
  roastId: string;
}

interface DeleteRoastResponse {
  roast_id: string;
  message: string;
}

export const useDeleteRoastMutation = () => {
  const supabase = useSupabaseTypedClient();
  const queryClient = useQueryClient();
  const { id: userId } = useCurrentUser();
  const { toastSuccess, toastError } = useToastWrapper();

  return useMutation<DeleteRoastResponse, string, DeleteRoastParams>({
    mutationFn: supabaseMutationFn(({ roastId }) =>
      supabase.functions.invoke<DeleteRoastResponse>(EdgeFunctionName.Roast, {
        body: { type: 'delete', roast_id: roastId },
      })
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TanstackQueryName.GetRoasts, userId] });
      queryClient.invalidateQueries({ queryKey: [TanstackQueryName.GetAllRoasts] });
      queryClient.invalidateQueries({ queryKey: [TanstackQueryName.GetProfileRoasts, userId] });
      toastSuccess('Roast deleted');
    },
    onError: (error) => {
      toastError(error || 'Failed to delete roast');
    },
  });
};
